// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.GroupVisibilityItem__container-ae9f04 {
  display: flex;
  align-items: center;
  padding: 8px 24px;
  cursor: pointer;
  user-select: none;
}

.GroupVisibilityItem__container-ae9f04:hover,
.GroupVisibilityItem__container-ae9f04:focus-visible {
  background-color: var(--base-17);
}

.GroupVisibilityItem__container-ae9f04:active {
  background-color: var(--base-20);
}

.GroupVisibilityItem__title-c1457e {
  font: var(--font-body-2);
  letter-spacing: var(--font-spacing-body-2);
  color: var(--base-110);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.GroupVisibilityItem__title-wrapper-ef6e21 {
  margin: 0 12px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex: 1;
  overflow: hidden;
}

.GroupVisibilityItem__switch-e74322 {
  margin-inline-start: auto;
  flex-shrink: 0;
}`, "",{"version":3,"sources":["webpack://./src/main/PopupManager/Popups/ChangeSpaceVisibilityPopup/GroupVisibilityItem/GroupVisibilityItem.styles.m.css"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,mBAAA;EACA,iBAAA;EACA,eAAA;EACA,iBAAA;AACF;;AAEA;;EAEE,gCAAA;AACF;;AAEA;EACE,gCAAA;AACF;;AAEA;EACE,wBAAA;EACA,0CAAA;EACA,sBAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;AACF;;AAEA;EACE,cAAA;EACA,aAAA;EACA,mBAAA;EACA,2BAAA;EACA,OAAA;EACA,gBAAA;AACF;;AAEA;EACE,yBAAA;EACA,cAAA;AACF","sourcesContent":[".container {\n  display: flex;\n  align-items: center;\n  padding: 8px 24px;\n  cursor: pointer;\n  user-select: none;\n}\n\n.container:hover,\n.container:focus-visible {\n  background-color: var(--base-17);\n}\n\n.container:active {\n  background-color: var(--base-20);\n}\n\n.title {\n  font: var(--font-body-2);\n  letter-spacing: var(--font-spacing-body-2);\n  color: var(--base-110);\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.title-wrapper {\n  margin: 0 12px;\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n  flex: 1;\n  overflow: hidden;\n}\n\n.switch {\n  margin-inline-start: auto;\n  flex-shrink: 0;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `GroupVisibilityItem__container-ae9f04`,
	"title": `GroupVisibilityItem__title-c1457e`,
	"title-wrapper": `GroupVisibilityItem__title-wrapper-ef6e21`,
	"titleWrapper": `GroupVisibilityItem__title-wrapper-ef6e21`,
	"switch": `GroupVisibilityItem__switch-e74322`
};
module.exports = ___CSS_LOADER_EXPORT___;
